module.exports = __webpack_public_path__ + "img/1573771167.893756a0.jpg";